module.exports = __webpack_public_path__ + "static/media/QD.cdc326c0.svg";